<script setup lang="ts">
import ParagraphTypeEpgSearch from '../../apps/tvmovie/theme/ParagraphTypeVueComponent/ParagraphTypeEpgSearch.vue'

import type { EpgWidgetParagraph } from '../../utils/paragraph-schema/paragraphs'

withDefaults(defineProps<{
  epgWidget: EpgWidgetParagraph['epgWidget'],
  isPreview?: boolean
}>(), {
  isPreview: false
})
</script>

<template>
  <ParagraphTypeEpgSearch :config="epgWidget.config"
                          :initial-filters="epgWidget.initialFilters"
                          :initial-broadcasts="epgWidget.initialBroadcasts"
                          :channels="epgWidget.channels"
                          :is-preview="isPreview" />
</template>
